<cam-overlay-panel
  [panelConfig]="{ matchTriggerWidth: false, manualTrigger: true }"
  position="right"
  class="d-flex flex-fill"
  #overlay
>
  <ng-template #panelTrigger>
    <div class="flex-fill" camClickOrDoubleClick [clickHandler]="this.show(overlay)" [dblClickHandler]="this.goTo">
      @if ($any(this.event().data) && $any(this.event().data).noteType && $any(this.event().data).noteType.colorSet) {
        <cam-color-set-displayer [colorSet]="$any(this.event().data).noteType.colorSet">
          <strong>{{ this.event().name }}</strong>
        </cam-color-set-displayer>
      } @else {
        <div class="event-card flex-column g-space-sm flex-full">
          <strong>{{ this.event().name }}</strong>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #panelContent>
    <div class="overlay">
      <cam-button (action)="this.edit()">Edit</cam-button>
    </div>
  </ng-template>
</cam-overlay-panel>

<cam-layout-full-panel
  [toggleState]="this.editModal.open()"
  (closeEvent)="this.editModal.open.set(false)"
  title="planning.edit-event.title"
  type="modal"
  size="lg"
>
  @if (this.editModal.open()) {
    <cam-planning-edit-event-content [modalState]="this.editModal"></cam-planning-edit-event-content>
  }
</cam-layout-full-panel>
